<template>
    <div class="c-form-checkbox">
        <input
            type="checkbox"
            :name="name"
            :required="required"
            :value="value"
            :id="name"
            :disabled="disabled"
            v-model="selection"
        /><label :for="name" v-html="label"></label>
    </div>
</template>

<script>
import Utils from '@classes/Utils';

export default {
    props: {
        value: {
            required: false
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        name: {
            type:String,
            default: () => Utils.generateUid()
        },
        label: {
            required: false
        }
    },
    data() {
        return {
            selection: null
        };
    },
    watch: {
        value(value) {
            this.selection = value;
        },
        selection(value) {
            this.$emit('input', value);
        }
    }
}
</script>
